export default __webpack_public_path__ + "static/media/medium.36a88427.gif";